module.exports = __webpack_public_path__ + "img/zb.84a8fc70.png";